import { checkDepartmentCountInRange, checkMaxRange } from './utils/navigation-guards';

export default [
  {
    name: 'travel-time-clients overview',
    path: '/settings/travel-time-clients',
    component: () => import('@web/pages/settings/travel-time-clients/TravelTimeClientsOverview.vue'),
    meta: { title: 'Reistijd & Koppelingen',
    },
    beforeEnter: [checkMaxRange],
    children: [
      {
        name: 'travel-time-clients',
        path: '',
        components: {
          detailColumn: () => import('@web/components/detail-column/EmptyStateDetailColumn.vue'),
        },
        meta: { 
          title: 'Reistijd en koppelingen',
          showContent: true
        },
      },
      {
        name: 'travel-time-clients travel-time edit',
        path: '/settings/travel-time/edit',
        components: {
          detailColumn: () => import('@web/pages/settings/travel-time-clients/detail-column/EditTravelTime.vue'),
        },
        meta: { 
          title: 'Reistijd en koppelingen',
          showContent: false
        },
        beforeEnter: [checkMaxRange, checkDepartmentCountInRange],
      },
      {
        name: 'travel-time-clients organisation edit',
        path: '/settings/organisation/edit/:id',
        components: {
          detailColumn: () => import('@web/pages/settings/travel-time-clients/detail-column/OrganisationEditPage.vue'),
        },
        meta: { 
          title: 'Zorginstelling aanpassen',
          showContent: false
        },
      },
    ]
  },
];
